import { Component, Input } from '@angular/core';

import { TimelineItemInterface } from '~/component/timeline/interfaces/item.interface';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent {
  @Input() public collection: TimelineItemInterface[] = [];
  @Input() public subTitle: string;

  public get hasCollection(): boolean {
    return !!this.collection.length;
  }
}
